import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const statsSlice = createAppSlice({
  name: 'stats',
  initialState,
  reducers,
});

export const { updateFetchedProjectStats, updateFetchedSessionStats, clearAllProjectStats, clearAllSessionStats } =
  statsSlice.actions;

export default statsSlice.reducer;
